var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgH8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 428 524",
    style: {
      enableBackground: "new 0 0 428 524"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 -12.8588 23.3387)",
    className: "st0",
    cx: 52.2,
    cy: 44,
    rx: 31.3,
    ry: 31.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 160.1,
    cy: 44,
    r: 31.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9239 -0.3827 0.3827 0.9239 3.5551 105.857)",
    className: "st0",
    cx: 267.9,
    cy: 44,
    rx: 31.3,
    ry: 31.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 375.7,
    cy: 44,
    r: 31.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.2,83.1h-5.5c-11,5.1-24.2,5.4-35.8,0h-5.5c-13,0-23.5,10.5-23.5,23.5v25.3c16.1,3.3,28.2,17.5,28.2,34.6 c0,8.8-3.3,16.9-8.6,23.1c-6.5,7.5-16,12.2-26.7,12.2c-10.5,0-20-4.7-26.5-12c-5.5-6.2-8.8-14.4-8.8-23.3 c0-17.1,12.2-31.4,28.4-34.6v-25.3c0-13-10.6-23.5-23.5-23.5h-5.5c-11,5.1-24.2,5.4-35.8,0h-5.5c-13,0-23.5,10.5-23.5,23.5v25.3 c16.1,3.3,28.2,17.5,28.2,34.6c0,8.8-3.3,16.9-8.6,23.1c-6.5,7.5-16,12.2-26.7,12.2c-10.5,0-20-4.7-26.5-12 c-5.5-6.2-8.8-14.4-8.8-23.3c0-17.1,12.2-31.4,28.4-34.6v-25.3c0-13-10.6-23.5-23.5-23.5H178c-11,5.1-24.2,5.4-35.8,0h-5.5 c-13,0-23.5,10.5-23.5,23.5v25.3c16.1,3.3,28.2,17.5,28.2,34.6c0,8.8-3.3,16.9-8.6,23.1c-6.5,7.5-16,12.2-26.7,12.2 c-10.5,0-20-4.7-26.5-12c-5.5-6.2-8.8-14.4-8.8-23.3c0-17.1,12.2-31.4,28.4-34.6v-25.3c0-13-10.6-23.5-23.5-23.5h-5.5 c-11,5.1-24.2,5.4-35.8,0h-5.5c-13,0-23.5,10.5-23.5,23.5V173c0,6.4,5.3,11.7,11.7,11.7h7.9v66.5c0,6.4,5.3,11.7,11.7,11.7h18.6 V229c0-14.1,10.7-25.8,24.4-27.3c1-0.1,2-0.2,3.1-0.2h6.4l0.8,0.4c10.3,4.8,22.2,4.8,32.5,0l0.8-0.4h6.4c1.1,0,2.1,0.1,3.2,0.2 c13.7,1.6,24.3,13.2,24.3,27.3v33.9h6V229c0-14.1,10.7-25.8,24.4-27.3c1-0.1,2-0.2,3.1-0.2h6.4l0.8,0.4c10.3,4.8,22.2,4.8,32.5,0 l0.8-0.4h6.4c1.1,0,2.1,0.1,3.2,0.2c13.7,1.6,24.3,13.2,24.3,27.3v33.9h6V229c0-14.1,10.7-25.8,24.4-27.3c1-0.1,2-0.2,3.1-0.2h6.4 l0.8,0.4c10.3,4.8,22.2,4.8,32.5,0l0.8-0.4h6.4c1.1,0,2.1,0.1,3.2,0.2c13.7,1.6,24.3,13.2,24.3,27.3v33.9h18.7 c6.4,0,11.7-5.3,11.7-11.7v-66.5h7.9c6.4,0,11.7-5.3,11.7-11.7v-66.5C422.6,93.5,412.1,83.1,399.2,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.8,166.4c0,7,2.7,13.4,7,18.3c5,5.5,12.2,9,20.2,9s15.2-3.5,20.2-9c4.4-4.8,7-11.2,7-18.3 c0-12.6-8.6-23.2-20.2-26.3c-2.3-0.6-4.6-0.9-7.1-0.9c-2.4,0-4.7,0.3-6.9,0.9C87.5,143.1,78.8,153.8,78.8,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.8,209.8c-1-0.2-2.1-0.3-3.2-0.3h-4.7c-12,5.3-25.5,5.3-37.5,0h-4.7c-1.1,0-2.1,0.1-3.1,0.3 c-9.3,1.5-16.4,9.5-16.4,19.2v33.9v32.6c0,4.2,3.5,7.7,7.7,7.7h11.9v70.5c0,4.2,3.5,7.7,7.7,7.7h31.3c4.2,0,7.7-3.5,7.7-7.7v-70.5 h11.9c4.2,0,7.7-3.5,7.7-7.7v-32.6V229C149.1,219.3,142,211.3,132.8,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.6,316.8v9.7c0.2,0,0.3,0,0.5,0h6.6l0.8,0.4c10.7,4.9,22.9,4.9,33.5,0l0.8-0.4h4.5v-7.6 c-6.1,4.7-13.8,7.6-22.1,7.6C205.7,326.5,197.1,322.8,190.6,316.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.2,303.1c4.2,0,7.7-3.5,7.7-7.7v-32.6V229c0-9.7-7.1-17.7-16.3-19.2c-1-0.2-2.1-0.3-3.2-0.3h-4.7 c-12,5.3-25.5,5.3-37.5,0h-4.7c-1.1,0-2.1,0.1-3.1,0.3c-9.3,1.5-16.4,9.5-16.4,19.2v33.9v32.6c0,4.2,3.5,7.7,7.7,7.7h2.7 c-1.5-4-2.4-8.3-2.4-12.8c0-19.9,16.2-36.2,36.2-36.2s36.2,16.2,36.2,36.2c0,4.5-0.8,8.8-2.4,12.8H249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186.6,166.4c0,7,2.7,13.4,7,18.3c5,5.5,12.2,9,20.2,9s15.2-3.5,20.2-9c4.4-4.8,7-11.2,7-18.3 c0-12.6-8.6-23.2-20.2-26.3c-2.3-0.6-4.6-0.9-7.1-0.9c-2.4,0-4.7,0.3-6.9,0.9C195.3,143.1,186.6,153.8,186.6,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.5,166.4c0,7,2.7,13.4,7,18.3c5,5.5,12.2,9,20.2,9s15.2-3.5,20.2-9c4.4-4.8,7-11.2,7-18.3 c0-12.6-8.6-23.2-20.2-26.3c-2.3-0.6-4.6-0.9-7.1-0.9c-2.4,0-4.7,0.3-6.9,0.9C303.1,143.1,294.5,153.8,294.5,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.4,209.8c-1-0.2-2.1-0.3-3.2-0.3h-4.7c-12,5.3-25.5,5.3-37.5,0h-4.7c-1.1,0-2.1,0.1-3.1,0.3 c-9.3,1.5-16.4,9.5-16.4,19.2v33.9v32.6c0,4.2,3.5,7.7,7.7,7.7h11.9v70.5c0,4.2,3.5,7.7,7.7,7.7h31.3c4.2,0,7.7-3.5,7.7-7.7v-70.5 H357c4.2,0,7.7-3.5,7.7-7.7v-32.6V229C364.7,219.3,357.6,211.3,348.4,209.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.3,335.4c-1.3-0.4-2.6-0.7-4-0.8c-0.7-0.1-1.3-0.1-2-0.1h-2h-2.8c-12.3,5.4-26.2,5.4-38.5,0h-4.8 c-0.2,0-0.3,0-0.5,0c-1.4,0-2.7,0.2-4,0.5c-1.4,0.3-2.7,0.8-4,1.4c-6.9,3.2-11.6,10.2-11.6,18.2v68.3c0,4.4,3.7,8,8,8h12.1v72.3 c0,4.4,3.6,8,8,8h32.2c4.4,0,8-3.6,8-8v-72.3h12.1c4.4,0,8-3.7,8-8v-68.3C259.5,345.6,253.5,337.9,245.3,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.2,303.1c2-3.9,3.1-8.2,3.1-12.8c0-15.5-12.6-28.2-28.2-28.2S187,274.8,187,290.3c0,4.6,1.1,9,3.1,12.8 c0.2,0.3,0.3,0.6,0.5,0.9c4.8,8.6,14,14.4,24.6,14.4c9,0,17-4.2,22.1-10.8C238.4,306.3,239.4,304.8,240.2,303.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH8);
export default __webpack_public_path__ + "static/media/h8.d26bea73d18104562846d245ed145925.svg";
export { ForwardRef as ReactComponent };